//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex'
import currencyMixin from '@/mixins/currency'
import Counter from '@/components/form/Counter'

export default {
  components: { Counter },

  mixins: [currencyMixin],

  props: {
    data: {
      type: Object,
      default: () => {},
    },
    hideCounter: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    imageStyle() {
      return {
        'background-image': `url(${this.data.image})`,
      }
    },
  },

  methods: {
    ...mapActions({
      updateProductQuantity: 'cart/updateProductQuantity',
      removeProductFromCart: 'cart/removeProductFromCart',
    }),
    /**
     * @description: Handle quantity update.
     * @param {*}
     * @return {*}
     */
    handleQuantity(value) {
      this.updateProductQuantity({ id: this.data.id, quantity: value })
    },
    /**
     * @description: Show confirm for delete product in cart.
     * @param {*}
     * @return {*}
     */
    handleDelete() {
      this.$bvModal
        .msgBoxConfirm(this.$t('car.confirm_delete'), {
          title: this.$t('delete'),
          buttonSize: 'sm',
          centered: true,
          size: 'sm',
          okTitle: this.$t('confirm'),
          cancelTitle: this.$t('cancel'),
        })
        .then((value) => {
          if (!value) {
            return
          }

          this.removeProductFromCart(this.data.id)
          this.checkCartIsEmpty()
        })
    },
    /**
     * @description: To product detail page.
     * @param {*}
     * @return {*}
     */
    toProductDetail() {
      this.$router.push(this.localePath(`/product/detail/${this.data.product_id}`))
    },
    /**
     * @description: Check cart is empty, then redirect to cart page.
     * @param {*}
     * @return {*}
     */
    checkCartIsEmpty() {
      if (this.products.length > 0) {
        return
      }

      this.$router.push(this.localePath('/cart'))
    },
  },
}
